import MojitoPresentation from 'mojito/presentation';
import PrebuiltBetView from 'modules/prebuilt-bets/prebuilt-bet/view/index.js';

const { FlexPane, Image, Text, DateTime } = MojitoPresentation.Components;

const PrebuiltBetBuilder = props => {
    const {
        mojitoTools: { config },
        event,
        market,
        onEventClick,
    } = props;

    return (
        <PrebuiltBetView
            config={config.view}
            market={market}
            event={event}
            onEventClick={onEventClick}
        >
            {config.view.showCardHeader && (
                <FlexPane class="ta-PrebuiltBetHeader" config={config.headerContainer}>
                    <Image config={config.matchAccaIcon} />
                    <FlexPane config={config.headerTextContainer}>
                        <Text config={config.eventName}>{event.name}</Text>
                        <FlexPane config={config.timeAndTypeContainer}>
                            <Text config={config.startTime}>
                                <DateTime
                                    config={config.startTimeFormat}
                                    dateTime={event.startTime}
                                />
                            </Text>
                            <Text config={config.typeName}>{` - ${event.typeName}`}</Text>
                        </FlexPane>
                    </FlexPane>
                </FlexPane>
            )}
        </PrebuiltBetView>
    );
};

export default PrebuiltBetBuilder;
